import type { TOC } from '@ember/component/template-only';
import Component from '@glimmer/component';
import { pluralize } from 'ember-inflector';
import UiPill from 'garaje/components/ui-pill';
import type LocationSubscriptionModel from 'garaje/models/location-subscription';
import type SubscriptionModel from 'garaje/models/subscription';
import { reads } from 'macro-decorators';

interface TrialDaysLeftMessageSignature {
  Args: {
    count: number;
    text: string;
  };
}

interface TrialDaysLeftPillSignature {
  Args: {
    count: number;
    text: string;
  };
}

interface TrialDaysLeftSignature {
  Args: {
    subscription: SubscriptionModel | LocationSubscriptionModel | null;
    pill?: boolean;
  };
}

const TrialDaysLeftMessage: TOC<TrialDaysLeftMessageSignature> = <template>
  {{pluralize @count "trial day"}} {{@text}}
</template>;

const TrialDaysLeftPill: TOC<TrialDaysLeftPillSignature> = <template>
  <UiPill data-test-trial-days-left @fill="blue">
    <TrialDaysLeftMessage @count={{@count}} @text={{@text}} />
  </UiPill>
</template>;

export default class TrialDaysLeftComponent extends Component<TrialDaysLeftSignature> {
  @reads('args.subscription.isOnTrial', false) declare isOnTrial: boolean;
  @reads('args.subscription.trialDaysLeft', 0) declare trialDaysLeft: number;
  @reads('args.pill', true) declare pill: boolean;

  get isTrialExpired(): boolean {
    const { onExpiredTrial, isExpiredDeliveriesTrial } = this.args.subscription || {
      onExpiredTrial: false,
      isExpiredDeliveriesTrial: false,
    };

    return !!(onExpiredTrial || isExpiredDeliveriesTrial || !this.trialDaysLeft);
  }

  get show(): boolean {
    return this.isOnTrial && !this.isTrialExpired;
  }

  <template>
    {{#if this.show}}
      {{#if this.pill}}
        <TrialDaysLeftPill @count={{this.trialDaysLeft}} @text="left" />
      {{else}}
        <TrialDaysLeftMessage @count={{this.trialDaysLeft}} @text="remaining" />
      {{/if}}
    {{/if}}
  </template>
}
